import './index.scss';
import React, { useState } from 'react'
import { NavLink } from 'react-router-dom';
import {hamburger, xmark } from '../../assets/cloudinaryUrls'
import { FormattedMessage } from 'react-intl';
import {logo} from '../../assets/cloudinaryUrls';

import { animateScroll as scroll } from 'react-scroll'; // Import animateScroll from react-scroll

function Navbar() {
  
  const [isOpen, setOpen] = useState(false)

  const handleCloseMenu = () => {
    setOpen(false)
  }
  
  const scrollToTop = () => {
    scroll.scrollToTop({
      duration: 1000, // Set the duration for the scroll animation (in milliseconds)
      smooth: 'linear', // Set the easing function for the animation (optional)
    });
  };


  return (
    <div className="nav-bar">
    <nav>
    <img src={logo} alt='globe' className='nav-logo' />
      <button className="hamburger" onClick={() => setOpen(!isOpen)}>
        <img src={isOpen ? xmark : hamburger} alt="hamburger" />
      </button>

      <div  className={isOpen ? "menu-items expanded" : "menu-items"}>
     

        <NavLink exact="true"  className="home-link" to="/" onClick={() => { handleCloseMenu(); scrollToTop(); }}>
          <h4><FormattedMessage id="navbar.home" /></h4>
        </NavLink>
        <NavLink exact="true"  className="about-link" to="/about" onClick={() => { handleCloseMenu(); scrollToTop(); }}>
          <h4><FormattedMessage id="navbar.about" /></h4>
        </NavLink>
        <NavLink exact="true"  className="buyers-link" to="/buyers" onClick={() => { handleCloseMenu(); scrollToTop(); }}>
          <h4><FormattedMessage id="navbar.buyers" /></h4>
        </NavLink>
        <NavLink exact="true"  className="owners-link" to="/owners" onClick={() => { handleCloseMenu(); scrollToTop(); }}>
          <h4><FormattedMessage id="navbar.owners" /></h4>
        </NavLink>
        {/* <NavLink exact="true"  className="properties-link" to="/properties" onClick={() => { handleCloseMenu(); scrollToTop(); }}>
          <h4><FormattedMessage id="navbar.properties" /></h4>
        </NavLink> */}
        <NavLink exact="true"  className="contact-link" to="/contact" onClick={() => { handleCloseMenu(); scrollToTop(); }}>
          <h4><FormattedMessage id="navbar.contact" /></h4>
        </NavLink>
      </div>
    </nav>
  </div>
  )
}

export default Navbar